const SimpleCard = ({ items = [] }) => {
    return (
        <div className="row">
            {items.map((i, j) => (
                <div key={j} className="col-12 col-sm-6 col-md-4 mb-3 card">
                    <div className="card-body">
                        <h5 style={{ color: `${i.color && i.color}` }} className="card-title fw-bold">{i.name}</h5>
                        <p className="card-text lineClamp1">{i.description}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}


export default SimpleCard;